// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"om","editButton":"on","formClass":"oo","rowClass":"op","columnClass":"oq","inputClass":"or","email":"os","mobile":"ot","cancelButton":"ou","submitButton":"ov"};